import React from "react";
import { Card, Form, Col } from "react-bootstrap";
import { capitalizeFirstLetter } from '../../components/JobApplication/Shared/Helpers';
function OnlineQuestions({ questionsList, onChoiceChange, onFreeTextChange, errors }) {

    return (
        <div>
            <h4 className="question-title">Induction Questions</h4>
            <p>Please read all questions carefully and review your answers before submitting.{/* ({`2/${questionsList.length}`} Questions Answered)*/}</p>
            {questionsList.map((question, index) => (
                <div key={index} className="question">
                    <p className="question-text">
                        Q{index + 1}. {question.questionText}
                    </p>


                    {question.questionType === 1 ? (
                        <div className="choices">
                            {question.choices.map((choice, choiceIndex) => (
                                <div key={choice.id} className="choice-text">
                                    <input
                                        className="custom-checkbox"
                                        type="checkbox"
                                        id={`choice-${question.questionId}-${choice.id}`}
                                        checked={choice.isChecked}
                                        onChange={(e) =>
                                            onChoiceChange(question.questionId, choice.id, e.target.checked)
                                        } />
                                    <label className="choice-text" htmlFor={`choice-${question.questionId}-${choice.id}`}>
                                        {choice.choiceText}
                                    </label>
                                </div>
                            ))}


                        </div>
                    ) : (
                        <Col sm={12} md={12} style={{ marginBottom: 10 }}>
                            <Form.Group>
                                <Form.Control
                                        className="answer-input"
                                        as="textarea"
                                        rows={2}
                                        maxLength="800"
                                        style={{ height: 'auto', borderColor: '#666' }}
                                        onChange={(e) => {
                                            onFreeTextChange(question.questionId, capitalizeFirstLetter(e.target.value))
                                        }}

                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    )}

                    {errors[question.questionId] && (
                        <div className="error-message" style={{ color: '#E74C3C', marginTop: '6px', marginLeft: '5px' }}>
                            <i className="fas fa-exclamation-circle"></i> {errors[question.questionId]}
                        </div>
                    )}


                    {index !== questionsList.length - 1 && (
                        <hr className="dashed-line" />
                    )}
                </div>
            ))}
        </div>


    );
}

export default OnlineQuestions;
